import moment from 'moment';
import { get } from 'lodash';
import { GridSortModel } from '@mui/x-data-grid';

export const PAGE_SIZES: number[] = [10, 25, 50, 100];

export const longDtFormat = 'MMMM Do, YYYY';
export const renderDateTimeFromCol =
  (colName, fmt = longDtFormat) =>
  p =>
    moment(p.row[colName]).format(fmt);

export const idGetter = p => get(atob(p?.row?.id)?.split(':'), '[1]', '');

// util to define standard grid col configs so we can change the defaults in one place for
const commonGridColConfig = {
  // https://mui.com/x/api/data-grid/grid-cell-params/
  headerAlign: 'left',
  align: 'left',
  sortable: true
};

// this allows us to define default column properties to reduce boilerplate code
export const mergeCommonGridColConfig = cfg => ({
  ...commonGridColConfig,
  ...cfg
});

// convert sort column name from camelCase to snake-case
export const getOrderBy = (sortOptions: GridSortModel, convertCamelToSnakeCase = true) => {
  if (!sortOptions.length) {
    return '';
  } else {
    const o = sortOptions[0];
    if (convertCamelToSnakeCase) {
      return `${o?.sort === 'desc' ? '' : '-'}${camelToSnakeCase(o?.field)}`;
    } else {
      return `${o?.sort === 'desc' ? '' : '-'}${o?.field}`;
    }
  }
};

// on the API side column names are snake-case, on the UI they are capitalCase so this is needed
const camelToSnakeCase = str =>
  str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
